import { uiSchema as uiSchemaType } from '../../components/DynamicForm/types';

export const extractRequiredFieldKeys = (uiSchema: uiSchemaType): string[] => {
    return Object.entries(uiSchema.properties)
        .filter(([_, value]) => value.isRequired)
        .map(([key]) => key);
};
